import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import userContext from '../../../../context/users/UserContext';
import { ACTIONS, USERTYPES } from '../../../../constants/Constants';
import SubModalityPreferences from './SubModalityPreferences';
import CustomToolTipHost from '../../../../components/CustomToolTipHost/CustomToolTipHost';
import { TooltipHost, Checkbox, ComboBox } from '@fluentui/react';
import { t, use } from "i18next";
import { choiceGroupStyles } from '../../helpers/Styles';
import ClearIcon from '../../../../components/SVGComponents/ClearIcon';

const AssignmentPreferences = (props) => {
    const [searchParams] = useSearchParams();
    const { roles, authenticated, loadByUsername, userId } = useContext(userContext);

    const [selectedModality, setSelectedModality] = useState([]);
    const [checkAllModality, setCheckAllModality] = useState(false);

    const [pediatricSpecialist, setPediatricSpecialist] = useState(props.values.pediatricSpecialist);
  const [selectedPediatricModalityId, setSelectedPediatricModalityId] = useState(props.values.selectedPediatricModalityId);
  
    useEffect(() => {
            if (!authenticated) {
        loadByUsername();
      }
    }, []);

    const resetSelectedPediatricModalityId = () => {
      setSelectedPediatricModalityId(props.values.selectedPediatricModalityId);
    };
  
    const resetPediatricSpecialist = () => {
      setPediatricSpecialist(props.values.pediatricSpecialist);
    }
  
    useEffect(() => {
      resetSelectedPediatricModalityId();
      resetPediatricSpecialist();
    }, [props.handleCancel]);
    
    let modalityList = [];
    props.modalityList.map((modality) => {
      modalityList.push({
        key: modality.id,
        text: modality.name,
      });
    });

    const getAllSubModName = (list,keyIndex) => {
      let allsubModString = "";
      let isOverFlow = false;
      list?.map((item,index) => {
        if(index >= keyIndex && index-keyIndex < 20){
          allsubModString += list[index];
          if (index < list.length - 1) {
            allsubModString += ", ";
          }
        } else{
          isOverFlow = true;
        } 
      });
      if(isOverFlow){
        allsubModString += "...";
      }
      return allsubModString;
    }

    const getFormattedSubModalities = (modality) =>{
      let subModName = [];
      modality?.subModalities.map((subMod, index)=>{
        subModName.push(subMod.serviceCode + ": "+ subMod.serviceName);
      })
      let list2 = "";
      {subModName.map((modality,index)=>{
        if(index < 5){
          list2 += modality + ", ";
        }  
      })}
      return (<>
      {getAllSubModofModFunc(modality, true) ? <div >
        <td style={{border:"none",padding:"8px",textAlign:"left"}}>
        {list2}
        <CustomToolTipHost content={getAllSubModName(getAllSubModofModFunc(modality, false),5)}>
           ....
        </CustomToolTipHost>
        </td>
        </div> : <td style={{border:"none",padding:"8px",textAlign:"left"}}>{list2}</td>
      }
      </> )
    }

    const getAllSubModofModFunc = (modality, len) =>{
      let subModName = [];
      modality?.subModalities.map((subMod, index)=>{
        subModName.push(subMod.serviceCode + ": "+ subMod.serviceName);
      })
      if(len){
        if(subModName.length > 5){
          return true;
        }
        return false;
      }else{
        return subModName;
      }
    }

    const selectedModalityfunc = () =>{
      setSelectedModality(props.selectedModalityWithSubModality.map((m)=>m.modalityId));
    }

    const handleAllModalityCheckboxClick = () => {
      if (checkAllModality) {
          props.setSelectedModalityWithSubModality([]);
          setCheckAllModality(false);
      } else {
          const allSelectedModalityWithSubModality = props.modalityWithSubModalityList.map(modality => ({
              modalityId: modality.id,
              subModalities: modality.subModality.map(subModality => subModality.id)
          }));
  
          props.setSelectedModalityWithSubModality(allSelectedModalityWithSubModality);
          setCheckAllModality(true);
      }
    };
  
    useEffect(()=>{
      selectedModalityfunc();
      console.log("Selected Modality with sub modality : ", props.selectedModalityWithSubModality);
      const allModalitiesSelected = props.modalityWithSubModalityList.every(modality => {
        return props.selectedModalityWithSubModality.some(selectedModality => selectedModality.modalityId === modality.id);
      });
      setCheckAllModality(allModalitiesSelected);
    },[props.selectedModalityWithSubModality]);

    const handlePediatricSpecialist = useCallback(() =>{
      setPediatricSpecialist(!pediatricSpecialist);
      props.values.pediatricSpecialist = !props.values.pediatricSpecialist;
      if(!pediatricSpecialist){
        setSelectedPediatricModalityId(modalityList.filter((m) => m.key != undefined).map((mod)=>mod.key))
      }else{
        setSelectedPediatricModalityId([]);
      }
    });

    const handlePediatricModalityClearButton = ()=>{
      setSelectedPediatricModalityId([]);
    }

    useEffect(()=>{
      console.log("selected pediatric modalityIds :",selectedPediatricModalityId);
      props.values.selectedPediatricModalityId = selectedPediatricModalityId;
    },[selectedPediatricModalityId])

    const getModalityNames = (modalityIds) => {
      let modalityNames = [];
      modalityNames = props.modalityList
        .filter((m) => modalityIds.includes( m.id))
        .map((modality) => modality.name);
      return modalityNames.join(", ");
    };
  
    return (
      <>
      <div className="tab-section">
      {((roles[0] === USERTYPES.FIRMADMIN) || (roles[0] === USERTYPES.ADMIN)) && <>
        {props.modalityList?.length > 0 && (props.state.action == ACTIONS.ADD || props.state.action == ACTIONS.EDIT)
          && ( <>
            <div className="ms-Grid" dir="ltr">
              <section className="sectionA"  style={{marginTop: "1.5rem"}}>
                  <p style={{ fontSize: "20px", fontWeight: "600", padding: "0px 0px",}}>
                    {t("user.pediatric-preferences")}
                  </p>
              </section>
              <div style={{ display: "flex", maxHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                  <p className="single-line-form-field-key">{t("user.pediatric-specialist")}</p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div style={{ marginTop: "5px" }}>
                    <Checkbox
                      defaultChecked={props.values.pediatricSpecialist}
                      value={props.values.pediatricSpecialist}
                      styles={choiceGroupStyles}
                      onChange={(e, isChecked) => handlePediatricSpecialist(isChecked)}
                    />
                  </div>
                </div>
              </div>
              {pediatricSpecialist && (
                <>
                  <div style={{ display: "flex", maxHeight: "60px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <p className="single-line-form-field-key">{t("user.pediatric-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value" style={{ display: "flex", alignItems: "center",color:"white" }}>
                      <div className="ms-sm12 ms-md8 ms-lg6 ms-xl10" >
                        <ComboBox
                          selectedKey={selectedPediatricModalityId}
                          placeholder="Select Modality"
                          options={[...modalityList]}
                          multiSelect
                          calloutProps={{ doNotLayer: true }}
                          onChange={(e, option) => {
                            let selected = option?.selected;
                            if (option) {
                              setSelectedPediatricModalityId((prevSelectedKeys) =>
                                selected ? [...prevSelectedKeys, option.key]
                                : prevSelectedKeys.filter((k) => k !== option.key ));}
                          }}
                        />
                      </div>
                      <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={()=> handlePediatricModalityClearButton()} style={{ paddingLeft: "5px"}}>
                        <CustomToolTipHost content="Clear"  >
                          <ClearIcon></ClearIcon>
                        </CustomToolTipHost>
                      </div>
                    </div>
                  </div> 
                </>  
              )}
            </div>

            <div className="ms-Grid" dir="ltr">
              <section className="sectionA"  style={{marginTop: "1.5rem"}}>
                <p style={{ fontSize: "20px", fontWeight: "600", padding: "0px 0px",}}>
                  {t("user.modality-preferences")}
                </p>
              </section>
                    
                <div className="ms-Grid-row">
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl9">
                    <p className="form-field-key" style={{ marginBottom: "20px", fontWeight: "bold" }}>
                    {t("user.select-auto-assignment-modality-preference")}
                    </p>
                  </div>
                </div>

                <div className="ms-Grid-row">
                  <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4">
                    <Checkbox
                      label="Select All"
                      onChange={handleAllModalityCheckboxClick}
                      id="all"
                      checked={checkAllModality==true}
                    />
                  </div>
                </div>

                <div className="ms-Grid-row">
                  {props.modalityWithSubModalityList.map((modality,index) => {
                    return (
                        <SubModalityPreferences 
                            index={index}
                            modality={modality}
                            modalityList={props.modalityList}
                            values={props.values}
                            setSelectedModalityWithSubModality={props.setSelectedModalityWithSubModality}
                            selectedModalityWithSubModality={props.selectedModalityWithSubModality}
                            selectedModalityfunc={selectedModalityfunc}
                            setSelectedModality={setSelectedModality}
                            selectedModality={selectedModality}
                        />
                    );
                  })}
                </div>
            </div>
        </>  )}
        {props.state.action == ACTIONS.VIEW && (
          <>
            <div className="ms-Grid" dir="ltr">
              <section className="sectionA"  style={{marginTop: "1.5rem"}}>
                  <p style={{ fontSize: "20px", fontWeight: "600", padding: "0px 0px",}}>
                    {t("user.pediatric-preferences")}
                  </p>
              </section>

              <div className="ms-Grid-row single-line-form-field" >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                      {t("user.pediatric-specialist")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{props.values.pediatricSpecialist ? "Yes" : "No"}</div>
                    </div>
                  </div>

                {!!pediatricSpecialist && (

                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                      {t("user.pediatric-modality-preference")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{getModalityNames(props.values.selectedPediatricModalityId)}</div>
                    </div>
                  </div>
                )}
            </div>

            <div className="ms-Grid" dir="ltr">
              <section className="sectionA"  style={{marginTop: "1.5rem"}}>
                <p style={{ fontSize: "20px", fontWeight: "600", padding: "0px 0px",}}>
                  {t("user.modality-preferences")}
                </p>
              </section>

                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <table className="borderless-table" style={{borderCollapse:"collapse", width:"100%"}}>
                        <thead>
                          <tr key="heading">
                            <th className="form-heading" style={{border:"none",padding:"8px",textAlign:"left",width:"30%"}}>Auto Assignment Modality Preference</th>
                            <th className="form-heading" style={{border:"none",padding:"8px",textAlign:"left"}}>Sub Modality</th>
                          </tr>
                        </thead>
                        <tbody>
                        {props.selectedModalitySubmodalityNames.map((modality, index)=>{
                          return(
                            <>
                            {/* <tr>
                            <td style={{border:"none",padding:"8px",textAlign:"left"}}>{modality.modalityName}</td>
                            {modality.subModalities.length > 0 ?  <>
                              {getFormattedSubModalities(modality)}
                              
                            </>
                            : <td style={{border:"none",padding:"8px",textAlign:"left"}}>-</td>}
                          </tr> */}
                            
                              {modality?.subModalities && modality.subModalities.length == 0 ? <>
                                <tr>
                                  <td style={{border:"none",padding:"8px",textAlign:"left"}}>{modality.modalityName}</td>
                                  <td style={{border:"none",padding:"8px",textAlign:"left"}}>-</td>
                                </tr>
                                </> : ""}
                                {modality?.subModalities.map((subMod, index)=>{
                                  return <tr>
                                  <td style={{border:"none",padding:"8px",textAlign:"left"}}>{modality.modalityName}</td>
                                  <td style={{border:"none",padding:"8px",textAlign:"left"}}>{subMod.serviceCode + ": " + subMod.serviceName}</td>    
                                  </tr>
                                  {/* <div key={index}>{subMod.serviceCode + ": " + subMod.serviceName}</div> */}
                                })}
                            </>
                          )
                        })}
                      </tbody>
                  </table>
                </div>
            </div>
          </>
        )
        }
        </>}
        </div>
      </>
    );
  }

export default AssignmentPreferences